import '../css/footer.scss';

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const currYear = new Date().getFullYear(),
    body = document.querySelector('body'),
    shieldModal = document.createElement('div'),
    frameCover = document.createElement('div'),
    // if stuff-footer div is present on the page, use it, otherwise create it
    footer = document.querySelector('.stuff-footer') || document.createElement('div'),
    colorbar = document.createElement('div'),
    footerLinks = document.createElement('div'),
    footerSecondary = document.createElement('div'),
    footerBreakingNews = document.createElement('div'),
    footerSocialLinks = document.createElement('div'),
    footerFacebook = document.createElement('a'),
    footerTwitter = document.createElement('a'),
    footerSnapChat = document.createElement('a'),
    footerShielded = document.createElement('span'),
    footerCopyright = document.createElement('div'),
    // list of text links of top half of footer
    links = [
      { "linkText": "Neighbourly", "linkURL": "https://www.neighbourly.co.nz/" },
      { "linkText": "Travel Bookings", "linkURL": "https://travel-booking.stuff.co.nz/" },
      { "linkText": "Play Stuff", "linkURL": "https://play.stuff.co.nz/" },
      { "linkText": "Stuff Coupons", "linkURL": "https://coupons.stuff.co.nz/" },
      { "linkText": "Death Notices", "linkURL": "https://deaths.stuff.co.nz/obituaries/stuff-nz" },
      { "linkText": "Stuff Events", "linkURL": "https://www.stuffevents.co.nz/" },
      { "linkText": "Advertising", "linkURL": "https://advertise.stuff.co.nz/" },
      { "linkText": "Careers", "linkURL": "https://careers.stuff.co.nz/" },
      { "linkText": "Privacy Policy", "linkURL": "https://stuff.co.nz/about-stuff/10648385/Privacy-Policy" },
      { "linkText": "Cookies Policy", "linkURL": "https://www.stuff.co.nz/about-stuff/300062240/stuff-cookies-policy-and-targeting-and-tracking-policy" },
      { "linkText": "Terms & Conditions", "linkURL": "https://stuff.co.nz/about-stuff/10647720/Stuffs-terms-and-conditions" },
      { "linkText": "Editorial Code", "linkURL": "https://www.stuff.co.nz/about-stuff/300106664/stuff-editorial-code-of-practice-and-ethics" },
      { "linkText": "Contact Us", "linkURL": "https://stuff.co.nz/about-stuff/33785/Contact-Us" }
    ];

  let linkList = "",
    breakingText = "";

    // set up shielded modal popup
  shieldModal.classList.add('shieldModal');
  frameCover.classList.add('frame_cover');
  frameCover.innerHTML = `<iframe sandbox="allow-forms allow-scripts allow-same-origin allow-popups" src="https://staticcdn.co.nz" style="opacity: .98; width:310px; height:420px;  max-height: 100%;" width="310" height="420" frameborder="0"></iframe>
  <div id="frame-close"><img style=" display: block; margin: 0 auto; width: 50px; height: 35px;  cursor: pointer;" src="https://staticcdn.co.nz/embed/close.png">`;
  shieldModal.appendChild(frameCover);

  //add classes to created divs
  footer.classList.add('stufffooter');
  colorbar.classList.add('stuff_color_bar');
  footerLinks.classList.add('footer_links');
  footerSecondary.classList.add('footer_secondary');
  footerBreakingNews.classList.add('footer_breakingnews');
  footerSocialLinks.classList.add('footer_social');
  footerCopyright.classList.add('footer_copyright');

  // set up social icon links
  footerFacebook.classList.add('footer_social-icon');
  footerFacebook.classList.add('footer_fb');
  footerFacebook.href = 'https://www.facebook.com/Stuff.co.nz';
  footerFacebook.setAttribute('title', 'Facebook');
  footerFacebook.setAttribute('target', '_blank');

  footerTwitter.classList.add('footer_social-icon');
  footerTwitter.classList.add('footer_twitter');
  footerTwitter.href = 'https://www.twitter.com/NZStuff';
  footerTwitter.setAttribute('title', 'Twitter');
  footerTwitter.setAttribute('target', '_blank');

  footerSnapChat.classList.add('footer_social-icon');
  footerSnapChat.classList.add('footer_snapchat');
  footerSnapChat.href = 'https://stuff.co.nz/national/blogs/from-the-newsroom/12231484/Join-Stuff-co-nz-in-Snapchat';
  footerSnapChat.setAttribute('title', 'Sanpchat');
  footerSnapChat.setAttribute('target', '_blank');

  footerShielded.classList.add('footer_social-icon');
  footerShielded.classList.add('footer_shielded');
  footerShielded.addEventListener('click', () => {
    shieldModal.style.display = 'block';
    footerShielded.style.visibility = 'hidden';
    let frameCloser = document.querySelector('#frame-close');
    frameCloser.addEventListener('click', () => {
      shieldModal.style.display = 'none';
      footerShielded.style.visibility = 'visible';
    });
  });

  // create text links
  links.forEach(link => {
    linkList += `<span class="footer_link">
      <a href="${link.linkURL}">${link.linkText}</a>
      </span>`;
  });

  // populate links div with text string of links
  footerLinks.innerHTML = linkList;

  breakingText = `<h4>Breaking news?</h4>
  Send your photos, videos, and tip-offs to<br>
  <a href="mailto:newstips@stuff.co.nz">newstips@stuff.co.nz</a>, or call us on 0800 697 883`;

  footerBreakingNews.innerHTML = breakingText;

  // append social icon links
  footerSocialLinks.appendChild(footerFacebook);
  footerSocialLinks.appendChild(footerTwitter);
  footerSocialLinks.appendChild(footerSnapChat);
  footerSocialLinks.appendChild(footerShielded);

  // populate copyright div
  footerCopyright.innerHTML = `&copy;${currYear}, Stuff Limited`;

  // append everything to the footer div
  footer.appendChild(colorbar);
  footer.appendChild(footerLinks);
  footerSecondary.appendChild(footerBreakingNews);
  footerSecondary.appendChild(footerSocialLinks);
  footer.appendChild(footerSecondary);
  footer.appendChild(footerCopyright);

  // if stuff-footer div not already on the page, append footer to body.
  if (!document.querySelector('.stuff-footer')) {
    body.appendChild(footer);
  }
  // place the Shielded popup on the page
  body.appendChild(shieldModal);
    }, false);

})();

